import { useForm } from "react-hook-form";
import { useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { maskPhone } from "../../../utils/masks";
import { useConcessionariasLista } from "../../../hooks/queries/cliente/useConcessionariasLista/useConcessionariasLista";
import { Tracking } from "../../../services/Tracking";
import { IAtendimentoConcessionariaForm } from "../../../types/agendamento";

export type IFormDeliveryConcessionaireV2Values = IAtendimentoConcessionariaForm;

const schema = z.object({
  nome: z.string().min(1, "Campo obrigatorio"),
  telefone: z.string().min(9, "Campo obrigatorio"),
  uuidConcessionaria: z.string().min(1, "Você precisa selecionar uma concessionária"),
});

export const useFormDeliveryConcessionaireV2 = () => {
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    register,
    formState: { errors },
  } = useForm<IFormDeliveryConcessionaireV2Values>({
    defaultValues: {
      nome: "",
      telefone: "",
      uuidConcessionaria: "",
    },
    resolver: zodResolver(schema),
    mode: "all",
  });

  const telefoneDigitado = watch("telefone");

  const { data: concessionariasData, isError: concessionariasComErro } =
    useConcessionariasLista();
  const concessionariasOptions = useMemo(
    () =>
      (concessionariasData ?? []).map((item) => ({
        value: item.uuid,
        label: item.nome,
        element: item,
      })),
    [concessionariasData],
  );

  useEffect(() => {
    if (concessionariasComErro) {
      Tracking.error(
        "mapa:agendamento/domicilio:buscar-concessionarias-falhou",
      );
      toast.error("Erro ao buscar a lista de concessionárias");
    }
  }, [concessionariasComErro]);

  useEffect(() => {
    setValue("telefone", maskPhone(telefoneDigitado));
  }, [telefoneDigitado, setValue]);

  return {
    control,
    handleSubmit,
    register,
    errors,
    concessionariasOptions,
  };
};
